import { BaseRepository } from '../../../infra/base.repository'
import { ConfigService } from '../../../infra/config'
import type { FormV2FormLink } from './form-v2-form-link'

export class FormV2FormLinksRepository extends BaseRepository<FormV2FormLink> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/forms-v2/form-links', token, cache)
    }
}
